import React, { createContext, useState, useContext } from 'react';
import axios from 'axios';
import secureLocalStorage from "react-secure-storage";
import { settings } from '../utils/appSettings';
import columnDataMatcher from '../utils/colDataMatcher';

// Create a context with default value as false
const ApiContext = createContext(false);

// Create the provider
export const ApiProvider = ({ children }) => {
    const { url, webapi, idClassCV, IdProfiloCV, IdProfiloLet, IdProfiloAltri } = settings;
    const [fieldsCV, setFieldsCV] = useState([]);
    const [fieldsLet, setFieldsLet] = useState([]);
    const [fieldsAltri, setFieldsAltri] = useState([]);

    const getToken = async () => {
        let apiUrl = `${url}${webapi}/api/Authentication`;
        let body = {
            username: process.env.REACT_APP_USERNAME,
            password: process.env.REACT_APP_PASSWORD,
            clientId: process.env.REACT_APP_CLIENT_ID,
            clientSecret: process.env.REACT_APP_CLIENT_SECRET,
        }
        try {
            let res = await axios.post(apiUrl, body);
            secureLocalStorage.setItem("accessToken", res.data.accessToken)
        } catch (err) {
            console.log(err)
        }
    }

    const getProfileInfo = async (id) => {
        let accessToken = secureLocalStorage.getItem("accessToken");
        let apiUrl = `${url}${webapi}/api/predefinedprofiles/${id}`;
        try {
            let res = await axios.get(apiUrl, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            return res.data.fields
        } catch (err) {
            console.log(err)
        }
    }

    const getAllProfileInfo = async () => {
        try {
            const ids = [IdProfiloCV, IdProfiloLet, IdProfiloAltri];
            const results = await Promise.all(ids.map(id => getProfileInfo(id)));
            return results;
        } catch (err) {
            console.log(err);
            return [];
        }
    };

    const getFieldValues = async (sField, simple = true) => {
        let accessToken = secureLocalStorage.getItem("accessToken");
        let apiUrl = `${url}${webapi}/api/v2/profiles/Values`;
        let body = {
            "fieldName": sField,
            "searchFilterDto": {
                "fields": [{
                    "className": "DocumentTypeFieldDTO",
                    "name": "DocumentType",
                    "value": idClassCV
                }]
            }
        }
        try {
            let res = await axios.post(apiUrl, body, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            return columnDataMatcher(res.data, simple)
        } catch (err) {
            console.log(err)
        }
    }

    const getAllFieldValues = async (aFields) => {
        try {
            const promises = aFields.map(sField => getFieldValues(sField));
            const results = await Promise.all(promises);
            return results;
        } catch (err) {
            console.log("Errore:", err);
        }
    };

    const getBufferId = async (file) => {
        let accessToken = secureLocalStorage.getItem("accessToken");
        let apiUrl = `${url}${webapi}/api/buffer/insert`;
        let formData = new FormData();
        formData.append('File', file);
        try {
            let res = await axios.post(apiUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${accessToken}`
                }
            });
            return res.data[0]
        } catch (err) {
            console.error('Errore:', err);
        }
    }

    const setProfileInfo = async (bufferIds, fields) => {
        let accessToken = secureLocalStorage.getItem("accessToken");
        let apiUrl = `${url}${webapi}/api/profiles`;
        let body = {
            "attachments": [],
            "authorityData": {
                "docNumber": null,
                "id": null,
                "office": null,
                "person": null,
                "protocol": null,
                "protocolDate": null,
                "shipping": null,
                "yourReferent": null
            },
            "constrainRoleBehaviour": 0,
            "document": {
                "bufferIds": bufferIds
            },
            "fields": fields,
            "generatePaProtocol": false,
            "id": 0,
            "notes": null,
            "paNotes": []
        }
        try {
            let res = await axios.post(apiUrl, body, {
                headers: { Authorization: `Bearer ${accessToken}` }
            })
            return res.data.docNumber
        } catch (err) {
            console.error('Errore:', err);
        }
    }

    const setAllProfileInfo = async (buffers, fieldsLet, fieldsAltri) => {
        try {
            const results = await Promise.all([
                setProfileInfo(buffers[1], fieldsLet),
                setProfileInfo(buffers[2], fieldsAltri)
            ]);
            return results;
        } catch (err) {
            console.error("Errore:", err);
        }
    };

    const setRelations = async (docCV, docLet, docAltri) => {
        let accessToken = secureLocalStorage.getItem("accessToken");
        let apiUrl = `${url}${webapi}/api/Relations/Insert`;
        let body = {
            "docNumber": docCV,
            "items": docAltri ? [
                {
                    "docNumber": docLet,
                    "relationType": 2
                },
                {
                    "docNumber": docAltri,
                    "relationType": 2
                }
            ] : [
                {
                    "docNumber": docLet,
                    "relationType": 2
                }
            ]
        }
        try {
            let res = await axios.post(apiUrl, body, {
                headers: { Authorization: `Bearer ${accessToken}` }
            })
            return res.data
        } catch (err) {
            console.error('Errore:', err);
        }
    }
    const ApiContextValue = {
        getToken,
        getAllProfileInfo,
        getFieldValues,
        getAllFieldValues,
        getBufferId,
        setProfileInfo,
        setAllProfileInfo,
        setRelations,
        fieldsCV,
        fieldsLet,
        fieldsAltri,
        setFieldsCV,
        setFieldsLet,
        setFieldsAltri

    };

    return (
        <ApiContext.Provider value={ApiContextValue}>
            {children}
        </ApiContext.Provider>
    );
};

export const useApi = () => {
    return useContext(ApiContext);
};